import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Merge = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="merge icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M7.21415 17C6.13464 17 5.59403 18.2673 6.35735 19.0085L11.1432 23.6554C11.6164 24.1149 12.3836 24.1149 12.8568 23.6554L17.6427 19.0085C18.406 18.2673 17.8654 17 16.7859 17H7.21415Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5052 2.68302C22.2325 3.51429 22.1483 4.77782 21.317 5.50518L14 11.9076V18C14 19.1046 13.1046 20 12 20C10.8955 20 10 19.1046 10 18V11C10 10.4233 10.249 9.87465 10.683 9.49487L18.683 2.49487C19.5143 1.76751 20.7778 1.85174 21.5052 2.68302Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.49487 2.68302C3.22224 1.85174 4.48576 1.76751 5.31704 2.49487L13.317 9.49487C13.7511 9.87465 14 10.4233 14 11V18C14 19.1046 13.1046 20 12 20C10.8955 20 10 19.1046 10 18V11.9076L2.68302 5.50518C1.85174 4.77782 1.76751 3.51429 2.49487 2.68302Z"
    />
  </svg>
)
